<!--
 * @Author: guoyu
 * @Date: 2020-04-28 12:39:24
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-10 14:33:09
 * @Description: 综合评分c端用户解释弹窗
 -->
<template>
  <el-dialog
    :visible.sync="popupShow"
    class="explain-container"
    custom-class="dialog-clear-style explain-container-wrap"
    :show-close="false"
    top="50vh"
    width="418px"
    append-to-body
  >
    <header class="explain-title">{{$t('upgrade_page_views_master_index_210')}}</header>
    <div class="explain-body">
      <template v-if="isGood">{{$t('components_scoreexplain_score1_explain_popup_1827')}}</template>
        <template v-else>{{$t('components_scoreexplain_score1_explain_popup_1828')}}</template>
    </div>
    <div class="explain-footer">
      <span class="footer-button" @click="close">{{$t('components_scoreexplain_score1_explain_popup_1829')}}</span>
    </div>
  </el-dialog>
</template>
<script>
export default {
  model: {
    event: 'close',
    prop: 'show',
  },
  props: {
    show: { type: Boolean, default: false },
    score: { type: [Number, String], default: 0 },
    isGood: { type: Boolean, default: false }
  },
  computed: {
    popupShow: {
      get() {
        return this.show;
      },
      set(newVal) {
        this.$emit('close', newVal);
      },
    },
  },
  methods: {
    close() {
      this.$emit('close', false);
    },
  },
};
</script>
<style lang="scss" scoped>
.explain-container {
  & /deep/ .explain-container-wrap {
    .el-dialog__body {
      background: #fff;
      border-radius: 8px;
      width: 418px;
      padding: 30px;
      border-radius: 8px;
      text-align: left;
      transform: translateY(-50%);
    }
  }
}
.explain-title {
  margin-bottom: 10px;
  line-height: 1;
  font-weight: 600;
  font-size: 18px;
}
.explain-body {
  margin-bottom: 25px;
  line-height: 27px;
  font-size: 16px;
  color: #666666;
}
.explain-footer {
  text-align: right;
  font-size: 0;
}
.footer-button {
  display: inline-block;
  height: 40px;
  width: 100px;
  line-height: 40px;
  cursor: pointer;
  text-align: center;
  background: linear-gradient(163.15deg, #ff4417 2.04%, #fb006e 60.91%);
  border-radius: 4px;
  font-size: 14px;
  color: #ffffff;
}
</style>
